<div class="eqbd-dialog">
  <h2 mat-dialog-title>{{ data.message }}</h2>

  <div class="toggle-row">
    <label class="fs-6 fw-semibold form-label mb-0 ms-7">EQBD Availability</label>
    <div class="toggle-switch">
      <input
        type="range"
        class="triple-toggle"
        min="0"
        max="2"
        step="2"
        [(ngModel)]="eqbdToggleValue"
        [ngStyle]="{
          backgroundColor: getToggleColor(eqbdToggleValue),
          border: getToggleBorder(eqbdToggleValue)
        }" />
      <span class="toggle-overlay" [ngClass]="{ 'overlay-right': eqbdToggleValue === 0 }">
        {{ eqbdToggleValue === 2 ? 'YES' : 'NO' }}
      </span>
    </div>
  </div>

  <mat-dialog-actions>
    <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onApprove()">Approve</button>
    <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onCancel()">Cancel</button>
  </mat-dialog-actions>
</div>
